import { Component, ElementRef, OnInit, ViewChild, NgModule, AfterViewInit, AfterViewChecked } from "@angular/core";
import { Router } from "@angular/router";
import { trigger, style, transition, animate, AnimationEvent, query, state, stagger } from "@angular/animations";
import { HttpHelpUtils } from "../../../utils/HttpHelpUtils";
import { LocalStorage } from "../../../utils/LocalStorage";
import { SessionStorage } from "../../../utils/SessionStorage";
import { BaseCommpont } from "src/app/utils/BaseCommpont";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CusRouteReuseStrategy } from "../../../utils/CusRouteReuseStrategy";
import { ConfirmationService, MessageService, MenuItem } from "primeng/api";
import { fromEvent, observable, Observable } from "rxjs";
import { environment, waterIframeUrl } from "./../../../../environments/environment";
import { RouterOutlet } from "@angular/router";
import { slideInAnimation } from "../../../utils/Animations";
import { MessageSub } from "./../../../utils/MessageSub";
import { PlatformLocation } from "@angular/common";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { NgxQrcodeElementTypes, NgxQrcodeErrorCorrectionLevels } from "@techiediaries/ngx-qrcode";
import { CommonMessageService } from "./../../../utils/Message.service";
import { TruckComponent } from "../../views/platform/carryManager/truck/truck.component";
import { DriverComponent } from "../../views/platform/carryManager/driver/driver.component";
import { WaterLoginEventService } from "./../../../utils/WaterLogin.service";
import { HttpHelpUtilsWater } from "../../../utils/HttpHelpUtilsWater";
declare const QRCode: any;
declare const html2canvas: any;
@Component({
  selector: "app-layout",
  templateUrl: "./layout.component.html",
  styleUrls: ["./layout.component.scss"],
  providers: [MessageService, ConfirmationService],
  animations: [
    trigger("inOutPaneAnimation", [
      transition(":enter", [
        style({ opacity: 0, transform: "translateX(-100%)", backgroundColor: "var(--surface-a)" }), //apply default styles before animation starts
        animate("750ms ease-in-out", style({ opacity: 1, transform: "translateX(0)", backgroundColor: "var(--surface-a)" })),
      ]),
      transition(":leave", [
        style({ opacity: 1, transform: "translateX(0)", backgroundColor: "var(--surface-a)" }), //apply default styles before animation starts
        animate("1600ms ease-in-out", style({ opacity: 0, transform: "translateX(100%)", backgroundColor: "var(--surface-a)" })),
      ]),
    ]),
    trigger("showPaneAnimation", [
      transition(":enter", [
        query(
          ":enter",
          [
            style({ opacity: 0, transform: "translateX(-100%)" }), //apply default styles before animation starts
            stagger("50ms", [animate("2s ease-in-out", style({ opacity: 1, transform: "translateX(0)" }))]),
          ],
          { optional: true },
        ),
      ]),
      transition(":leave", [
        query(
          ":leave",
          [
            style({ opacity: 1, transform: "translateX(0)" }), //apply default styles before animation starts
            stagger("100ms", [animate("150ms ease-in-out", style({ opacity: 0, transform: "translateX(100)" }))]),
          ],
          { optional: true },
        ),
      ]),
    ]),
    trigger("overlayMenuAnimation", [
      transition(":enter", [style({ opacity: 0, transform: "scaleY(0.8)" }), animate(".12s cubic-bezier(0, 0, 0.2, 1)", style({ opacity: 1, transform: "*" }))]),
      transition(":leave", [animate(".1s linear", style({ opacity: 0 }))]),
    ]),
    slideInAnimation,
  ],

})
export class LayoutComponent implements OnInit, AfterViewInit, AfterViewChecked {
  validateForm: FormGroup;
  chooseForm: FormGroup;
  bc = new BaseCommpont();

  @ViewChild("userOperate") userOperate: ElementRef;
  @ViewChild("subMneu") subMneu: ElementRef;
  @ViewChild("outlet", { static: false }) outlet!: RouterOutlet;
  menuWidth = "240px";
  selectMenuId = 0;
  activeCitemName = "";
  toggleUserInfo = false;
  toggleBoxInfo = false;
  showSetThemeFlag = false;
  personalDetailsForm: FormGroup;
  themeType = "";
  dataType = "";
  headerSetType = "";
  updatePwdFlag = false;
  personalDetailsFlag = false;
  // username = '';
  // realname = '';
  // companyName = '';
  loginData = {};
  formToken = ""; // 表单formToken
  formId = ""; // 表单formId
  menuList = [];
  baseMenuList = [];
  shipperId = null;
  showQCodeFlag = false; // 货主码
  showBulkOrderQCodeFlag = false; // 货源码
  favoriteManuList = [];
  favoriteMenuMap = {};
  tabMenu: any[] = [{ menuname: "首页", id: 0, link: "home" }];
  menuHeight = "calc(100% - 64px)";

  windowResizeFlag = false;

  loginAgentId: any;
  loginCustId: any;

  checkLoginStatus = false;

  satelliteOptions: any;
  is_shipper: any;
  isShowShipper = true;
  sizeList = [
    { size: "12px", toggle: false },
    { size: "13px", toggle: false },
    { size: "14px", toggle: true },
    { size: "15px", toggle: false },
    { size: "16px", toggle: false },
  ];

  sideButtonItems = [
    {
      icon: "pi pi-phone",
      command: () => { },
    },
    {
      icon: "pi pi-envelope",
      command: () => { },
    },
    {
      icon: "pi pi-window-maximize",
      command: () => { },
    },
  ];

  //默认行数
  defaultRows = 20;
  // 默认查询时间区间, 单位天
  searchRange = 15;

  constructor(
    private router: Router,
    public httpHelp: HttpHelpUtils,
    private localStorage: LocalStorage,
    private sessionStorage: SessionStorage,
    private fb: FormBuilder,
    private elementRef: ElementRef,
    private messageService: MessageService,
    private configSrv: ConfirmationService,
    private messageSub: MessageSub,
    private platformLocation: PlatformLocation,
    private waterLoginEventService: WaterLoginEventService,
    private commMessService: CommonMessageService,
    public httpHelpWater: HttpHelpUtilsWater,
  ) {
    this.platformLocation.onPopState(() => {
      this.router.navigate(["login"]);
    });
    console.log("router===", router);
  }
  // 侧边栏调整
  toggleSilderMenu() {
    this.menuWidth = this.menuWidth == "240px" ? "64px" : "240px";
    this.httpHelp.menuWidth = this.menuWidth;
  }
  iframeFlag = "0";
  toggleWaterMenu(waterMenu) {
    console.log("waterMenu", waterMenu);
    waterMenu.toggle = !waterMenu.toggle;
  }
  showWaterIframe = false
  updateWaterIframe(show = true, link = null) {
    console.log("object", document.getElementById("water-iframe"));
    const token = window.sessionStorage.getItem("psgToken");
    if (!document.getElementById("water-iframe")) {
      const theiframe = document.createElement("iframe");
      theiframe.id = "water-iframe";
      theiframe.src = environment.is_local ? waterIframeUrl.local : environment.is_dev ? waterIframeUrl.dev : "";
      theiframe.style.width = "100%";
      theiframe.style.height = "calc(100vh - 102px)";
      theiframe.style.display = show ? "block" : "none";
      document.getElementById("water-frame-box").appendChild(theiframe);
      theiframe.contentWindow.postMessage({
        type: 'rySetToken',
        token
      }, '*')
      if (link) {
        theiframe.contentWindow.postMessage({
          type: 'ryNavigate',
          path: link
        }, '*')
      }


      this.listenWater();
    } else {
      const theiframe = document.getElementById("water-iframe") as HTMLIFrameElement;
      theiframe.style.display = show ? "block" : "none";
      theiframe.contentWindow.postMessage({
        type: 'rySetToken',
        token
      }, '*')
      if (link) {
        theiframe.contentWindow.postMessage({
          type: 'ryNavigate',
          path: link
        }, '*')
      }

    }
    this.showWaterIframe = show
  }
  listenWater() {
    const waterIframe = document.getElementById("water-iframe") as HTMLIFrameElement;
    // waterIframe.src = environment.baseUrlWater
    console.log(environment.baseUrlWater);
    // 等 iframe 加载完
    if (waterIframe) {
      waterIframe.addEventListener("load", () => {
        console.log("waterIframe加载完毕");
        // 直接读 iframe 的全局变量
        // waterIframe.contentWindow.postMessage({ type: "SET_USER", payload: { id: 1, name: "张三" } }, "http://localhost:4300");
        window.addEventListener("message", (event: any) => {
          if (event.data.type == "login" && event.data.value) {
            window.localStorage.setItem("waterToken", event.data.value);
            this.waterLoginEventService.emitLogin();
          } else if (event.data.type == "logout" && event.data.value == "ok") {
            window.localStorage.removeItem("waterToken");
            this.waterLoginEventService.emitLogout();
          } else if (event.data.type == 'saveUrl') {
            window.sessionStorage.setItem('waterUrl', event.data.value)
          }
          // 1️⃣ 校验来源
          // if (event.origin !== "http://localhost:4300") return;

          // 2️⃣ 使用数据
          // console.log("从子页面收到的消息", event.data);
        });
      });
    }
  }
  toggleMenu(item, mini?) {
    console.log("展开二级菜单", item, mini);
    // if (item.id === 2068 && !window.localStorage.getItem("waterToken")) {
    //   //水运菜单跳转逻辑

    //   this.router.navigate(["water/login.html"]).then((_) => {
    //     const waterIframe = document.getElementById("water-iframe") as HTMLIFrameElement;
    //     if (!waterIframe.contentWindow) return;
    //     waterIframe.contentWindow.postMessage(
    //       {
    //         type: "clearToken",
    //       },
    //       "*",
    //     );
    //     this.updateWaterIframe(true);
    //   });
    //   return;
    // }
    this.menuList.map((i) => {
      if (item["menuname"] == i["menuname"]) {
        i["toggle"] = mini || !i["toggle"];
      } else {
        i.toggle = false;
      }
    });
  }
  routeQueryParams = {};
  updateWaterTab() {
    if (this.tabMenu.find((item) => item.id == 999999)) {
      this.selectMenuId = 999999;
    } else {
      this.selectMenuId = 999999;
      this.tabMenu.push({
        menuname: "水运平台",
        id: 999999,
        link: "/water/login.html",
      });
    }
  }
  selectWaterMenuId = 0
  /**
   * 页面跳转激活tab
   * @param citem
   */
  navegateUrl(citem, item?) {
    console.log("citem", citem);

    if (citem.menuname == "商城后台管理") {
      window.localStorage.setItem("iframeFlag", "1");
      this.iframeFlag = "1";
      this.updateIframe();
      setTimeout(() => {
        const iframe = document.getElementById("shop-iframe") as HTMLIFrameElement;
        console.log("iframe", iframe);
        if (iframe.contentWindow != null) {
          iframe.contentWindow.postMessage(
            {
              path: "/shop/baseInfo/rules",
              token: window.sessionStorage.getItem("psgToken"),
            },
            "*", // 允许发送给任何origin，但生产环境不建议使用
          );
          console.log("发送完毕");
        }
      }, 1000);
    } else {
      window.localStorage.setItem("iframeFlag", "0");
      this.iframeFlag = "0";
      this.updateIframe();
    }
    try {
      if (citem.link == "dataAnaly/waybillAnaly/waybillAnaly.html") {
        window.open(environment.downUrl + "/analy/");
        // var a = document.createElement('a')
        // a.href = 'https://pfm.51hahy.com/otms/analy';
        // a.download = '运单分析'
        // a.target = '_blank'
        // a.click()
        return;
      }
    } catch (e) { }
    if (item) {
      this.toggleMenu(this.menuItem, true);
    }
    if (citem.link.includes('wtms')) {
      console.log("走水运")
      this.selectWaterMenuId = citem.id
      this.router.navigate(["water/login.html"]).then((res) => {
        this.updateWaterTab()
        this.updateWaterIframe(true, citem.link.slice(5));
        return res;
      });
      return;
    }
    this.activeCitemName = citem.title;
    let commonUrl = "";

    // 只有当路径不是以home/ sys/、agent/ 或 shipper/ 开头时，才添加前缀
    const needsPrefix = citem.link != "home" && !citem.link.startsWith("sys/") && !citem.link.startsWith("agent/") && !citem.link.startsWith("shipper/");

    if (needsPrefix) {
      if (this.loginAgentId == 0 && this.loginCustId != 0) {
        commonUrl = "shipper/";
      }

      if (this.loginAgentId != 0 && this.loginCustId == 0) {
        commonUrl = "agent/";
      }
    }
    let queryParams = {};
    this.updateWaterIframe(false);
    return this.router
      .navigate([commonUrl + citem.link], {
        queryParams: this.routeQueryParams,
      })
      .then((res) => {
        this.routeQueryParams = {};
        let tabMenuAddFlag = true;
        this.tabMenu.forEach((e, i) => {
          if (e.id === citem.id) {
            tabMenuAddFlag = false;
          }
        });
        if (tabMenuAddFlag) {
          this.tabMenu.push(citem);
        }
        this.selectMenuId = citem.id;
        return res;
      });
  }

  subMenus = [];
  showSubMenu = false;
  menuItem = {};
  onSubMenuOpen(item) {
    console.log("item=====>", item);
    this.menuItem = item;
    this.menuList.map((i) => {
      if (item["menuname"] == i["menuname"]) {
        i["min-toggle"] = true;
        this.subMenus = item["children"];
        this.showSubMenu = true;
        this.bindSubmenuOutsideClickListener(this.outsideSubmenuClickListencer);
      } else {
        i["min-toggle"] = false;
      }
    });
  }

  onHideSubmenu() {
    this.showSubMenu = false;
    this.unbindOutsideClickListener(this.outsideSubmenuClickListencer);
  }

  showUserInfo(event) {
    this.toggleUserInfo = true;
    this.bindOutsideClickListener(this.outsideClickListener);
    event.preventDefault();
  }

  showBoxInfo(event) {
    this.toggleBoxInfo = true;
    event.preventDefault();
  }

  // 显示联系方式
  showContractPhone() { }

  outsideClickListener: any;
  outsideSubmenuClickListencer: any;

  isOutsideTopbarMenuClicked(event): boolean {
    return !(this.userOperate.nativeElement.isSameNode(event.target) || this.userOperate.nativeElement.contains(event.target));
  }

  isOutsideLeftMenuClicked(event): boolean {
    if (!this.subMneu || !this.subMneu.nativeElement) {
      return;
    }
    return !(this.subMneu.nativeElement.isSameNode(event.target) || this.subMneu.nativeElement.contains(event.target));
  }

  bindOutsideClickListener(listener) {
    if (!listener) {
      listener = (event) => {
        if (this.isOutsideTopbarMenuClicked(event)) {
          this.toggleUserInfo = false;
          this.unbindOutsideClickListener(listener);
        }
      };
      document.addEventListener("click", listener);
    }
  }

  bindSubmenuOutsideClickListener(listener) {
    if (!listener) {
      listener = (event) => {
        if (this.isOutsideLeftMenuClicked(event)) {
          this.showSubMenu = false;
          this.unbindOutsideClickListener(listener);
        }
      };
      document.addEventListener("click", listener);
    }
  }

  unbindOutsideClickListener(listener) {
    if (listener) {
      document.removeEventListener("click", listener);
      listener = null;
    }
  }

  chooseSize(item) {
    this.sizeList.map((i) => {
      if (i["size"] === item["size"]) {
        i["toggle"] = true;
      } else {
        i["toggle"] = false;
      }
    });
    document.documentElement.style.fontSize = item["size"];
    this.localStorage.set("theme-size", item["size"]);
  }

  // 选择设置喜欢的菜单
  chooseFavorite(item, event) {
    let tempFlag = true;
    this.favoriteManuList.forEach((e) => {
      if (e["id"] == item["id"]) {
        tempFlag = false;
      }
    });
    if (tempFlag) {
      this.favoriteManuList.push(item);
    }
    this.favoriteMenuMap = [];
    this.favoriteManuList.forEach((e) => {
      this.favoriteMenuMap[e["id"]] = true;
    });
    this.menuList = [
      ...[
        {
          menuname: "常用菜单",
          icon: "pi pi-star",
          children: this.favoriteManuList,
        },
      ],
      ...this.baseMenuList,
    ];
    this.localStorage.setObject("favoriteMenuList", this.favoriteManuList);
    event.stopPropagation();
  }

  // 取消设置某一个喜欢菜单
  removeChooseFavorite(item, event, menuname) {
    this.favoriteManuList = this.favoriteManuList.filter((e) => e["id"] !== item["id"]);
    this.favoriteMenuMap = {};
    this.favoriteManuList.forEach((e) => {
      this.favoriteMenuMap[e["id"]] = true;
    });
    if (this.favoriteManuList.length == 0) {
      this.menuList = this.baseMenuList;
    } else {
      this.menuList = [
        ...[
          {
            menuname: "常用菜单",
            icon: "pi pi-star",
            toggle: menuname == "常用菜单" ? true : false,
            children: this.favoriteManuList,
          },
        ],
        ...this.baseMenuList,
      ];
    }

    this.localStorage.setObject("favoriteMenuList", this.favoriteManuList);
    event.stopPropagation();
  }

  themeMap = {
    light: "assets/theme/res-theme/bootstrap4-light-purple.css",
    dark: "assets/theme/res-theme/bootstrap4-dark-purple.css",
    "light-blue": "assets/theme/res-theme/bootstrap4-light-blue.css",
  };

  // 切换主题
  changeTheme(type: string) {
    const linkElement = document.getElementById("theme-link");
    const origThemeType = this.localStorage.get("theme-type");

    linkElement.setAttribute("href", linkElement.getAttribute("href").replace(this.themeMap[origThemeType], this.themeMap[type]));

    if (type.indexOf("light") != 0) {
      this.httpHelp.loadingGif = "assets/file/image/loading-w.gif";
    } else {
      this.httpHelp.loadingGif = "assets/file/image/loading-w.gif";
    }
    this.themeType = type;
    this.localStorage.set("theme-type", type);
  }

  // 切换数据格式
  changeDataType(dataType) {
    this.localStorage.set("data-type", dataType);
    this.dataType = dataType;
  }

  // 切换头部是否隐藏
  changeHeaderSet(headerType) {
    this.localStorage.set("header-set-type", headerType);
    if (headerType == "show") {
      this.httpHelp.pageHeight = "calc(100vh - 102px)";
      this.menuHeight = "calc(100% - 64px)";
    } else {
      this.httpHelp.pageHeight = "calc(100vh - 38px)";
      this.menuHeight = "calc(100% - 194px)";
    }
    this.headerSetType = headerType;
  }

  // 默认行数设置
  changeDefaultRowsSet(rows) {
    this.localStorage.set("table-rows-type", rows + "");
    this.defaultRows = rows;
  }

  // 默认查询天数范围
  changeDefaultSearchRange(days) {
    this.localStorage.set("search-range", days + "");
    this.searchRange = days;
  }

  prepareRoute(outlet: RouterOutlet) {
    return outlet?.activatedRouteData?.["animation"];
  }

  handleChange(item) {
    console.log("TBGSITEM=", item);
    if (item.menuname == "商城后台管理") {
      window.localStorage.setItem("iframeFlag", "1");
      this.iframeFlag = "1";
      this.updateIframe();
      setTimeout(() => {
        const iframe = document.getElementById("shop-iframe") as HTMLIFrameElement;
        console.log("iframe", iframe);
        if (iframe.contentWindow != null) {
          iframe.contentWindow.postMessage(
            {
              path: "/shop/baseInfo/rules",
              token: window.sessionStorage.getItem("psgToken"),
            },
            "*", // 允许发送给任何origin，但生产环境不建议使用
          );
          console.log("发送完毕");
        }
      }, 1000);
    } else {
      window.localStorage.setItem("iframeFlag", "0");
      this.iframeFlag = "0";
      this.updateIframe();
    }
    if (item.id == 999999) {
      this.router.navigate(["water/login.html"]).then(_ => {
        this.updateWaterTab()
        this.updateWaterIframe(true);
        const waterIframe = document.getElementById("water-iframe") as HTMLIFrameElement;

        waterIframe.contentWindow.postMessage({
          type: 'ryNavigate',
          path: window.sessionStorage.getItem('waterUrl') ? window.sessionStorage.getItem('waterUrl') : '/basic/receive'
        }, '*')

      })
      return
    }
    this.updateWaterIframe(false);
    this.selectMenuId = item.id;
    let commonUrl = "";

    // 只有当路径不是以 sys/、agent/ 或 shipper/ 开头时，才添加前缀
    const needsPrefix = item.link != "home" && !item.link.startsWith("sys/") && !item.link.startsWith("agent/") && !item.link.startsWith("shipper/");

    if (needsPrefix) {
      if (this.loginAgentId == 0 && this.loginCustId != 0) {
        commonUrl = "shipper/";
      }

      if (this.loginAgentId != 0 && this.loginCustId == 0) {
        commonUrl = "agent/";
      }
    }
    this.router.navigate([commonUrl + item.link]);
  }

  // 用户信息
  queryUserInfo() {
    this.personalDetailsFlag = true;
    // const userInfo = {
    //     id: 489,
    //     url: 'userInfo/userInfo.html',
    //     title: '个人设置',
    //     icon: '',
    // };
    // this.navegateUrl(userInfo);
  }

  handleDelete(item, $event) {
    if (item.menuname == "商城后台管理") {
      document.getElementById("shop-iframe").remove();
    }
    if (item.id === 999999) {
      this.updateWaterIframe(false);
    }
    $event.stopPropagation();
    $event.preventDefault();
    if (item.id === this.selectMenuId) {
      this.selectMenuId = 0;
      this.router.navigate(["home"]);
    }
    this.tabMenu = this.tabMenu.filter((e) => e.id !== item.id);
    let commonUrl = "";
    if (this.loginAgentId == 0 && this.loginCustId != 0) {
      commonUrl = "shipper/";
    }

    if (this.loginAgentId != 0 && this.loginCustId == 0) {
      commonUrl = "agent/";
    }

    CusRouteReuseStrategy.handlers[commonUrl + item.link] = null;
    CusRouteReuseStrategy.closeTabUrl = item.link;
  }

  swPlatform() {
    this.router.navigate(["swichPlate"]);
  }

  // skipHome() {
  //   this.menu.forEach((e, i) => {
  //     this.menu[i].active = false;
  //   });
  //   this.activeCitemName = '';
  //   this.selectMenuId = 0;
  //   this.router.navigate(['home']);
  //   this.skipHomeFlag = true;
  // }

  resizeWindow() {
    this.windowResizeFlag = !this.windowResizeFlag;
    const el = document.body;
    const isFullscreen = document.fullscreenElement;
    if (!isFullscreen) {
      if (el.requestFullscreen) {
        el.requestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  }
  // showQCdoe() {
  //   const that = this;
  //   this.showQCodeFlag = true;
  //   this.qCodeValue = this.tempQCodeUrl + this.branch_id;
  // }
  downloadQCdoe() {
    // const that = this;
    // html2canvas(document.getElementById('qrcode')).then((canvas) => {
    //   const canvasImg = canvas.toDataURL('image/png');
    //   const a = document.createElement('a');
    //   a.href = canvasImg;
    //   a.download = '发车方二维码';
    //   a.click();
    // });
  }
  // // 修改密码
  updateUserPwd() {
    this.validateForm.reset();
    this.updatePwdFlag = true;
    this.httpHelp.get("psg/common/get-form-token", {}).then((res) => {
      if (res["status"] == "success") {
        this.formToken = res["data"]["formToken"];
        this.formId = res["data"]["formId"];
      } else {
      }
    });
  }

  saveUserPwd() {
    const password = this.validateForm.controls.oldPassword.value;
    const new_password = this.validateForm.controls.newPassword.value;
    const repeat_password = this.validateForm.controls.newPassword1.value;
    if (password == null) {
      //   this.httpHelp.message.add({ key: 'tc', severity: 'error', detail: '请输入旧密码！' });
      this.bc.showMessage(this.messageSub, "请输入旧密码！", "error");
      return;
    }
    if (new_password == null) {
      // this.httpHelp.message.add({ key: 'tc', severity: 'error', detail: '请输入新密码！' });
      this.bc.showMessage(this.messageSub, "请输入新密码！", "error");
      return;
    }
    if (repeat_password == null) {
      // this.httpHelp.message.add({ key: 'tc', severity: 'error', detail: '请输入确认密码！' });
      this.bc.showMessage(this.messageSub, "请输入确认密码！", "error");
      return;
    }
    if (this.validateForm.controls.newPassword.value !== this.validateForm.controls.newPassword1.value) {
      // this.httpHelp.message.add({ key: 'tc', severity: 'error', detail: '两次密码不一致' });
      this.bc.showMessage(this.messageSub, "两次密码不一致", "error");
      return;
    }
    const pattern = /^(?![^a-zA-Z]+$)(?!\D+$).{6,20}/;
    if (!pattern.test(new_password) || !pattern.test(repeat_password)) {
      // this.httpHelp.messageSub.add({ key: 'tc', severity: 'error', detail: '密码必须包含字母、数字以及特殊字符且不少于8位' });
      this.bc.showMessage(this.messageSub, "密码必须包含字母、数字以及特殊字符且不少于8位", "error");
      return;
    }
    const options = {
      token: this.formToken,
      formId: this.formId,
    };
    for (const i in this.validateForm.controls) {
      if (this.validateForm.controls[i].invalid) {
        this.validateForm.controls[i].markAsDirty();
        this.validateForm.controls[i].updateValueAndValidity();
        return;
      }
      options[i] = this.validateForm.controls[i].value;
    }

    this.configSrv.confirm({
      message: "确定保存数据吗？",
      icon: "pi pi-exclamation-triangle",
      header: "保存确认",
      acceptLabel: "确定",
      rejectLabel: "取消",
      rejectButtonStyleClass: "p-button-raised p-button-text p-button-plain",
      accept: () => {
        this.httpHelp.loadingBlock = true;
        this.httpHelp
          .post("sys/user/update-password", options)
          .then((res) => {
            this.httpHelp.loadingBlock = false;
            if (res["status"] == "success") {
              this.updatePwdFlag = false;
              // this.localStorage.remove(environment.tokenKey);
              // this.httpHelp.message.add({ key: 'tc', severity: 'success', detail: '密码修改成功，请重新登陆' });
              this.router.navigate(["login"]);
            } else {
              this.bc.showMessage(this.messageSub, res["message"], "error");
            }
          })
          .catch((err) => {
            console.log(err);
          });
      },
      reject: () => { },
      key: "confirmResetPassword",
    });
  }

  // 退出登录，清空路由数据
  logout() {
    this.sessionStorage.remove(environment.tokenKey);
    this.sessionStorage.remove("loginData");
    this.sessionStorage.remove("is_shipper");
    this.router.navigate(["login"]);
  }
  logoutWater() {
    window.localStorage.removeItem("waterToken")
    setTimeout(() => {
      this.toggleUserInfo = false;
    })
    this.loadPageInfoConfig()
    this.router.navigate(["water/login.html"]).then((_) => {
      const waterIframe = document.getElementById("water-iframe") as HTMLIFrameElement;
      if (!waterIframe.contentWindow) return;
      waterIframe.contentWindow.postMessage(
        {
          type: "clearToken",
        },
        "*",
      );
      this.updateWaterIframe(true);
    });
  }
  // 加载页面初始配置
  // data=[];
  loadPageInfoConfig() {
    const that = this;
    this.httpHelp.get("sys/menu/routes", {}).then((res) => {
      setTimeout(() => {
        this.checkLoginStatus = true;
      }, 1000);
      if (res["status"] == "success") {
        that.baseMenuList = res["data"]["list"];
        if (this.favoriteManuList.length != 0) {
          that.menuList = [
            ...[
              {
                menuname: "常用菜单",
                icon: "pi pi-star",
                children: this.favoriteManuList,
              },
            ],
            ...res["data"]["list"].map(menu => {
              return {
                ...menu,
                children: menu.children.map(nav => {
                  return {
                    ...nav,
                    link: nav.link === 'sys/role/role.html' ? (Number(window.sessionStorage.getItem('is_shipper')) > 1 ? 'shipper/sys/role/role.html' : nav.link) : nav.link === 'sys/user/user.html' ? (Number(window.sessionStorage.getItem('is_shipper')) > 1 ? 'shipper/sys/user/user.html' : nav.link) : nav.link
                  }
                })
              }
            }),
          ];
          console.log("=============that.menuList", that.menuList)
          that.menuList.forEach((e, i) => {
            if (i == 0) {
              e["toggle"] = true;
              e["icon"] = "pi pi-star";
            } else {
              e["toggle"] = false;
            }
          });
        } else {
          that.menuList = res["data"]["list"].map(menu => {
            return {
              ...menu,
              children: menu.children.map(nav => {
                return {
                  ...nav,
                  link: nav.link === 'sys/role/role.html' ? (Number(window.sessionStorage.getItem('is_shipper')) > 1 ? 'shipper/sys/role/role.html' : nav.link) : nav.link === 'sys/user/user.html' ? (Number(window.sessionStorage.getItem('is_shipper')) > 1 ? 'shipper/sys/user/user.html' : nav.link) : nav.link
                }
              })
            }
          })
          that.menuList.forEach((e) => {
            e["toggle"] = false;
          });
        }

      } else {
        if (res["defailCode"] == 3003) {
          that.router.navigate(["/login"]);
        }
      }
    });
  }

  // 获取登录用户信息
  getLoginUserInfo() {
    this.httpHelp.get("psg/common/get-login-user", {}).then((res) => {
      if (res["status"] == "success") {
        this.loginData = res["data"];
        this.localStorage.setObject("loginData", this.loginData);
        console.log(this.loginData, "this.loginData----------------");
        this.loginAgentId = res["data"]["agentId"];
        this.loginCustId = res["data"]["custId"];
        this.sessionStorage.setItem("is_shipper", this.loginCustId);
      } else {
        this.sessionStorage.setItem("is_shipper", "1");
      }
      // 判断账号是否货主端
      this.is_shipper = this.sessionStorage.getItem("is_shipper");
      if (this.is_shipper == 0) {
        this.isShowShipper = false;
      }
    });
  }

  qCodeValue = ""; // 货主码
  orderqCodeValue = ""; // 货源码
  elementType = NgxQrcodeElementTypes.IMG;
  correctionLevel = NgxQrcodeErrorCorrectionLevels.HIGH;
  //
  tuoyunfangmaDialog = false;
  onTuoyunfangmaDialogShow() {
    setTimeout(() => {
      new QRCode(document.getElementById("tuoyunfangmaDialogQRcode2"), {
        text: this.qCodeValue,
        width: 200,
        height: 200,
        colorDark: "#000",
        colorLight: "#fff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    });
  }
  downloadImg() {
    const el = document.getElementById("tuoyunfangmaDialogQRcode2Box");

    html2canvas(el, {
      scale: 2, // 提高清晰度（很重要）
      useCORS: true, // 允许跨域图片
      backgroundColor: "#fff", // 背景色
    }).then((canvas) => {
      const link = document.createElement("a");
      link.href = canvas.toDataURL("image/png");
      link.download = "dom.png";
      link.click();
    });
    //     const container = document.querySelector('#tuoyunfangmaDialogQRcode2');
    //   if (!container || container.children.length < 2) {
    //     alert('二维码还没生成');
    //     return;
    //   }

    //   const img:any = container.children[1]; // 第 2 个子元素
    //   if (!img || img.tagName !== 'IMG' || !img.src) {
    //     alert('未找到二维码图片');
    //     return;
    //   }

    //   const a = document.createElement('a');
    //   a.href = img.src;
    //   a.download = 'qrcode.png';
    //   document.body.appendChild(a);
    //   a.click();
    //   a.remove();
  }
  // 展示货主码
  showShipperQcode() {
    const that = this;
    // this.shipperBulkOrderQCodeDetail = item;
    // that.qCodeValue = environment.driverQCodeUrl + 'shipper_id-' + this.shipperId;
    that.qCodeValue = this.shipperId + "";
    console.log(": that.qCodeValue", that.qCodeValue);
    that.tuoyunfangmaDialog = true;
  }

  // 展示货源码
  showShipperOrderQcode() {
    const that = this;
    // this.shipperBulkOrderQCodeDetail = item;
    that.orderqCodeValue = environment.shipperQCodeUrl + "bulk_no-" + this.shipperId;
    that.showBulkOrderQCodeFlag = true;
  }

  showMsg(msgData: {}) {
    const detail = msgData["messageDetail"];
    if (!detail) {
      return;
    }
    this.messageService.add({
      key: msgData["key"] ? msgData["key"] : "showMsg",
      severity: msgData["messageType"] ? msgData["messageType"] : "success",
      detail: detail,
    });
  }
  updateIframe() {
    if (!document.getElementById("shop-iframe")) {
      let version = window.localStorage.getItem("mallVersion") || "1.0.0";
      const theiframe = document.createElement("iframe");
      theiframe.id = "shop-iframe";
      theiframe.src = environment.is_local ? "http://192.168.2.107:3200?v=" + version : environment.is_dev ? "https://landdev.sujiawuliu.cn:6443/mall/?v=" + version : "https://land.sujiawuliu.cn/mall/?v=" + version;
      theiframe.style.width = "100%";
      theiframe.style.height = "calc(100vh - 102px)";
      theiframe.style.display = this.iframeFlag == "1" ? "block" : "none";
      document.getElementById("layout-frame-box").appendChild(theiframe);
    } else {
      document.getElementById("shop-iframe").style.display = this.iframeFlag == "1" ? "block" : "none";
    }
  }
  waterHome: any = {};
  //获取水运菜单
  getWaterMenus() {
    return this.httpHelpWater.get("platform/queryLoginUserInfo", {}).then((res: any) => {
      console.log("接口返回:", res);
      // if (res && res['code'] != 0) {
      // // this.router.navigate(['login']); // 已自动注释
      // console.log('接口失败，loading 不会结束');
      // this.messageService.add({ key: 'tc', severity: 'error', detail: res['msg'] })
      // return;
      // }
      if (res.data.branch_id > 1) {
        this.waterHome = {
          menutype: 0,
          parentName: null,
          sort: 0,
          menuname: "水运平台",
          link: "home",
          children: [],
          id: 999999,
        }
        return
      }
      console.log("接口成功，准备设置 checkLoginStatus = true");
      setTimeout(() => {
        console.log("设置 checkLoginStatus = true");
        // this.checkLoginStatus = true;
      }, 1000);
      let tMenus: MenuItem[] = [
        {
          label: "首页",
          routerLink: ["home"],
          icon: "pi pi-pw pi-home",
          command: (event) => {
            // self.skipHome();
          },
        },
      ];
      if (res["data"]["changePwd"] == "Y") {
        // this.show = false;
        // this.validateForm.reset();
        // this.updatePwdFlag = true;
      } else {
        const resData: any[] = res["data"]["resList"];
        // self.username = res["data"].username;
        // self.realname = res["data"].realname;
        // self.rolename = res["data"].roleName;
        // self.branch_id = res["data"].branch_id;
        // self.branch_name = res["data"].branchName;
        resData.forEach((e) => {
          if (e["p_id"] == 1 && e["title"] != "根菜单") {
            const currTab = {
              id: e["id"],
              label: e["title"],
              icon: "pi " + e["icon"],
              command: (event) => {
                // self.activeMenu(event.item.id)
              },
              items: [],
              expanded: false,
            };
            resData.forEach((child) => {
              if (child["p_id"] === e["id"]) {
                currTab.items.push({
                  id: child["id"],
                  url: child["url"],
                  routerLink: [child["url"]],
                  routerLinkActive: "dddsdadsa",
                  label: child["title"],
                  icon: child["icon"],
                  command: (event) => {
                    // self.navegateUrl({
                    //   id: event.item.id,
                    //   url: event.item["url"],
                    //   title: event.item["label"],
                    //   icon: event.item["icon"],
                    // });
                  },
                });
              }
            });

            tMenus.push(currTab);
          }
        });
        console.log("menuList", this.menuList, "tMenu", tMenus);
        this.menuList.forEach((menuListItem) => {
          if (menuListItem.id == 2068) {
            tMenus[0].items = [];
            menuListItem.children = tMenus.map((tMenusItem) => {
              return {
                menutype: 0,
                parentName: null,
                sort: 0,
                menuname: tMenusItem.label,
                link: "",
                pid: 0,
                toggle: false,
                id: tMenusItem.id,
                icon: tMenusItem.icon,
                children: tMenusItem.items.map((tMenusItemChildren) => {
                  return {
                    menutype: 0,
                    parentName: null,
                    sort: 0,
                    menuname: tMenusItemChildren.label,
                    link: tMenusItemChildren.url,
                    children: [],
                    id: tMenusItemChildren.id,
                    water: true,
                  };
                }),
              };
            });
            menuListItem.toggle = false;
            let waterHome = {
              menutype: 0,
              parentName: null,
              sort: 0,
              menuname: "水运平台",
              link: "home",
              children: [],
              id: 999999,
            };
            menuListItem.children[0] = waterHome;
            this.waterHome = waterHome;
            console.log("处理后的menuList", this.menuList);
          }
        });

        // self.menus = tMenus;
      }

      // this.router.navigate(["home"]);
    });
  }
  ngOnInit(): void {

    this.waterLoginEventService.onLogin$.subscribe((_) => {
      //水运登录成功n
      // this.getWaterMenus().then((_) => {
      //   this.selectMenuId = this.waterHome.id;
      //   this.menuList.forEach((item) => {
      //     if (item.id == 2068) {
      //       item.toggle = true;
      //     }
      //   });
      //   this.router.navigate(["/water/login.html"]);
      // });
    });
    this.waterLoginEventService.onLogout$.subscribe((_) => {
      //水运退出登录成功
      this.loadPageInfoConfig();
    });

    this.getCardExpireNum();
    // 获取登录用户信息
    this.getLoginUserInfo();
    // 获取二维码相关
    this.httpHelp.get("psg/shipper/get-shipper", {}).then((res) => {
      if (res["status"] == "success") {
        if (res["data"]) {
          this.shipperId = res["data"]["id"];
        }
      } else {
      }
    });

    // 初始化主题配置
    const size = this.localStorage.get("theme-size") || "14px";
    this.sizeList.map((i) => {
      if (i["size"] == size) {
        i.toggle = true;
      } else {
        i.toggle = false;
      }
    });
    this.themeType = this.localStorage.get("theme-type");

    // 初始化选择菜单，动态获取菜单列表之后，根据缓存中是否有对应值比对
    const menuData = this.localStorage.getObject("favoriteMenuList");
    if (menuData["noData"] == "null") {
      this.favoriteManuList = [];
    } else {
      this.favoriteManuList = this.localStorage.getObject("favoriteMenuList");
      this.favoriteMenuMap = {};
      this.favoriteManuList.forEach((e) => {
        this.favoriteMenuMap[e["id"]] = true;
      });
    }

    this.dataType = this.localStorage.get("data-type") || "table";

    this.headerSetType = this.localStorage.get("header-set-type") || "show";
    if (this.headerSetType == "show") {
      this.httpHelp.pageHeight = "calc(100vh - 102px)";
      this.menuHeight = "calc(100% - 64px)";
    } else {
      this.httpHelp.pageHeight = "calc(100vh - 38px)";
      this.menuHeight = "calc(100% - 194px)";
    }

    this.defaultRows = Number(this.localStorage.get("table-rows-type") || 50);

    this.searchRange = Number(this.localStorage.get("search-range") || 15);

    // 加载页面菜单列表
    this.loadPageInfoConfig();

    // 监听宽度改变
    this.menuWidth = window.innerWidth <= 1680 ? "64px" : "240px";
    fromEvent(window, "resize").subscribe((e) => {
      this.menuWidth = window.innerWidth <= 1680 ? "64px" : "240px";
      this.httpHelp.menuWidth = this.menuWidth;
    });
    this.validateForm = this.fb.group({
      // oldPassword: [null, [Validators.required]],
      // newPassword: [null, [Validators.required, Validators.pattern('^(?![^a-zA-Z]+$)(?!\D+$).{8,20}')]],
      // newPassword1: [null, [Validators.required, Validators.pattern('^(?![^a-zA-Z]+$)(?!\D+$).{8,20}')]]
      oldPassword: [null],
      newPassword: [null],
      newPassword1: [null],
    });
    // 防止页面刷新路由不跳转
    this.router.navigate(["home"]);

    // 路由地址跳转
    let urlObserver: Observable<any> = Observable.create((observable) => {
      let data = this.commMessService.get("payLoad");
      this.activeCitemName = data.title;
      data.menuname = data.title;
      data.link = data.url;
      this.router.navigate([data.url]).then((res) => {
        let tabMenuAddFlag = true;
        this.tabMenu.forEach((e, i) => {
          if (e["id"] === data["id"]) {
            tabMenuAddFlag = false;
          }
        });
        if (tabMenuAddFlag) {
          this.tabMenu.push(data);
        }
        this.selectMenuId = data["id"];
      });
      observable.next();
    });

    this.commMessService.set("myObserver", urlObserver);

    // 公共消息提示
    let myObserver: Observable<any> = Observable.create((observable) => {
      let msgSubData = this.messageSub.get("msgSub");
      if (msgSubData) {
        this.showMsg(msgSubData);
      }
      observable.next();
    });
    this.messageSub.set("msgObser", myObserver);
  }
  ngAfterViewInit(): void {
  }
  isGetWaterFrameBox = false;
  ngAfterViewChecked(): void {
    if (document.getElementById("water-frame-box") && this.isGetWaterFrameBox == false) {
      this.isGetWaterFrameBox = true;
      this.updateWaterIframe(false);
    }
  }
  showCode = false;
  showQcCode() {
    this.showCode = !this.showCode;
  }
  cardExpireNum = 0;
  cardExpireNumTruck = 0;
  showCardNumDetail(type: "driver" | "truck") {
    let that = this;
    //每次点击过期按钮之后跳转到车辆、司机页面都会重新查询列表
    console.log("this.menuList", this.menuList);
    if (type == "driver") {
      // Handle driver card expiration logic
      this.menuList.forEach((fitem) => {
        if (fitem.id == 796) {
          fitem.children.forEach((citem) => {
            if (citem.id == 74) {
              this.routeQueryParams = {
                certificateExpiredCount: 1,
              };
              this.navegateUrl(citem, fitem).then((res) => {
                console.log("res", res);
                const instance = that.outlet.component;
                if (instance != null && instance != undefined) {
                  if (instance instanceof TruckComponent) {
                    console.log("车辆组件实例", instance);
                    setTimeout(() => {
                      instance.changeIsMemberTruckItemStatus("0", false);
                      instance.changeCertificateExpiredCountItems(1);
                    }, 300);
                  }
                  if (instance instanceof DriverComponent) {
                    setTimeout(() => {
                      instance.changeCertificateExpiredCountItems(1);
                    }, 300);
                  }
                }
              });
            }
          });
        }
      });
    } else if (type == "truck") {
      // Handle truck card expiration logic
      this.menuList.forEach((fitem) => {
        if (fitem.id == 73) {
          fitem.children.forEach((citem) => {
            if (citem.id == 76) {
              this.routeQueryParams = {
                certificateExpiredCount: 1,
                isMemberTruck: 0,
              };
              this.navegateUrl(citem, fitem).then((res) => {
                const instance = that.outlet.component;
                if (instance != null && instance != undefined) {
                  if (instance instanceof TruckComponent) {
                    console.log("车辆组件实例", instance);
                    setTimeout(() => {
                      instance.changeIsMemberTruckItemStatus("0", false);
                      instance.changeCertificateExpiredCountItems(1);
                    }, 300);
                  }
                  if (instance instanceof DriverComponent) {
                    setTimeout(() => {
                      instance.changeCertificateExpiredCountItems(1);
                    }, 300);
                  }
                }
              });
            }
          });
        }
      });
    }
  }
  getCardExpireNum() {
    this.httpHelp.get("psg/drivers/get-driver-card-expire-num-all").then((res) => {
      this.cardExpireNum = res["data"];
    });
    this.httpHelp.get("psgsys/sj/truck/get-truck-card-expire-num-all").then((res) => {
      this.cardExpireNumTruck = res["data"];
    });
  }
  isWaterToken() {
    return window.localStorage.getItem("waterToken")
  }
}
